import React from "react";
import { useTranslation } from "react-i18next";
import "../i18n";

const ShareButton = ({ style, isMobile, params }) => {
  const { t } = useTranslation();

  const handleShare = async () => {
    if (navigator.share) {
      try {
        const longUrl = window.location.href;

        let url = `https://api.albertgenauapp.com/tinyurl`;

        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Auth-Key": params?.key,
            "Client-Service": params?.service,
          },
          body: JSON.stringify({
            long_url: longUrl,
          })
        });

        const json = await response.json();

        if (json?.status?.code === 200) {
          const shortUrl = json.result;
          await navigator.share({
            title: t("title3dShare"),
            text: t("desc3dShare"),
            url: shortUrl
          });
        } else {
          alert(t("shareError"));
        }
      } catch (error) {
        console.error("Paylaşım iptal edildi veya hata oluştu:", error);
      }
    } else {
      // Flutter WebView fallback
      const message = JSON.stringify({
        action: "share",
        title: t("title3dShare"),
        text: t("desc3dShare"),
        url: window.location.href
      });

      const bridge = window.ReactNativeWebView || window.FlutterBridge;
      if (bridge && typeof bridge.postMessage === "function") {
        bridge.postMessage(message);
      } else {
        alert(t("shareError"));
      }
    }
  };

  return <button style={{ ...style, top: isMobile ? 5 : 170, left: isMobile ? 250 : 20 }} onClick={handleShare}>{t("share")}</button>;
};

export default ShareButton;
